import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import GoogleMapReact from 'google-map-react';
import {withRouter} from "react-router-dom";
import {blue, red, orange, green} from '@material-ui/core/colors'
import { observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { pending, done } from '../stores/State';
import Map from '@material-ui/icons/Map';
import Tooltip from '@material-ui/core/Tooltip';
import supercluster from 'points-cluster';

const GoogleAPIKey = 'AIzaSyDkbWl9EDNRQOTBRhuLRJ9EYyj0uOewkQ8';  // TODO: Should not be hardcoded, convert into env var
const MAP_HEIGHT = 700;
const DEFAULT_CENTER = {lat: 60.192059, lng: 	24.945831};
const DEFAULT_ZOOM = 10;
const Marker = ({ backgroundColor, borderColor, text, title }) => {

  return (
  <Tooltip title={title} placement="top">
    <div style={
      {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 30,
        height: 30,
        backgroundColor: backgroundColor || red[800],
        borderColor: borderColor || red[200],
        borderWidth: 3,
        borderStyle: 'solid',
        borderRadius: '50%',
        color: 'white',
        cursor: 'pointer',
      }}>
        <span>{text}</span>
      </div>
    </Tooltip>
)};

const ClusterMarker = ({ title, text }) => {

  return (
    <Tooltip title={title} placement="top">
      <div style={
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 30,
          height: 30,
          backgroundColor: 'white',
          borderColor: 'black',
          borderWidth: 3,
          borderStyle: 'solid',
          borderRadius: '50%',
          color: 'black'
        }}>
          <span>{text}</span>
        </div>
      </Tooltip>
)};

@inject('store')
@observer
class InventoryLocationsMap extends Component {

  @observable defaultCenter = DEFAULT_CENTER
  @observable defaultZoom = DEFAULT_ZOOM
  @observable center = DEFAULT_CENTER
  @observable zoom = DEFAULT_ZOOM

  mapContainerElement = undefined;
  map = undefined;
  maps = undefined;

  constructor() {
    super()
    this.state = {
      
    }
  }

  componentDidMount(){
    this.reactionHandler = reaction(()=>this.props.store.inventoryLocationStore.inventoryLocations, (locations)=>{
      this.updateDefaultBounds();
    })
  }

  componentWillUnmount(){
    this.reactionHandler();
  }

  getClusters = props => {
    const  store  = this.props.store.inventoryLocationStore;
    if(!store.inventoryLocations) return [];

    const points = store.inventoryLocations
      .filter(location=>location.coordinates)
      .map(location => ({ id: location.id, lat: location.coordinates.coordinates[1], lng: location.coordinates.coordinates[0], location }))

    const clusters = supercluster(points, {
      minZoom: 0,
      maxZoom: 16,
      radius: 60,
    });

    return clusters(this.state.mapOptions);
  };

  createClusters = props => {
    this.setState({
      clusters: this.state.mapOptions.bounds
        ? this.getClusters(props).map(({ wx, wy, numPoints, points }) => ({
            lat: wy,
            lng: wx,
            numPoints,
            id: `${numPoints}_${points[0].id}`,
            points,
          }))
        : [],
    });
  };

  handleMapChange = ({ center, zoom, bounds }) => {
    this.setState(
      {
        mapOptions: {
          center,
          zoom,
          bounds,
        },
      },
      () => {
        this.createClusters(this.props);
      }
    );
  }

  updateDefaultBounds(){
    const store = this.props.store.inventoryLocationStore;
    if(!store.inventoryLocations) return;
    
    const bounds = new this.maps.LatLngBounds();

    store.inventoryLocations
      .filter(location=>location.coordinates)
      .map(location => ({ lat: location.coordinates.coordinates[1], lng: location.coordinates.coordinates[0] }))
      .forEach(location => bounds.extend(location));
  
    this.map.fitBounds(bounds);
  }

  handleRowClick(location){
    this.props.history.push(`/inventory_locations/${location.id}`);    
  }

  renderMarkers(){
    const { classes, theme, store } = this.props;
    const { clusters } = this.state;
    const { inventoryAlert } = theme;

    const locations = store.inventoryLocationStore.inventoryLocations;

    if(!clusters) return null;
    return clusters.map((item, i) => {
      if (item.numPoints > 1) {
        const title = item.points.map(point => <div>{point.location.customer.name} - {point.location.name} - {(point.location.fill_rate*100).toFixed(0)}%</div>)
        return <ClusterMarker
        key={`cluster-${i}`}
        lat={item.lat}
        lng={item.lng}
        text={`${item.numPoints}`}
        title={title}
        />
      }
      const location = item.points[0].location;
      if (!location) {
        return null;
      }

      var fillRate = location.fill_rate;
      
      var color = undefined;
      if(fillRate > 0.8) color = red
      else if(fillRate > 0.6) color = orange   
      else color = green

      return(
        <Marker
        key={location.id}
        lat={item.lat}
        lng={item.lng}
        text={`${(fillRate*100).toFixed(0)}%`}
        backgroundColor={color[800]}
        borderColor={color[300]}
        title={`${location.customer.name} - ${location.name}`}
        />
      );
    });
  }

  onGoogleAPILoaded = ({map, maps}) => {
    this.map = map;
    this.maps = maps;
    this.updateDefaultBounds();
  }

  handleMarkerClick(key){
    if (key.includes('cluster')) {
      return null;
    }
    this.props.history.push(`/inventory_locations/${key}`);        
  }

  render() {
    const { classes } = this.props;
    const  store  = this.props.store.inventoryLocationStore;
    
    return (
      <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'><Map/>Inventory locations</Typography>
        { store.inventoryLocationsState === pending && <CircularProgress /> }
        { store.inventoryLocationsState === done && <div className={classes.mapContainer} ref={ element=> this.mapContainerElement = element}>
          <GoogleMapReact
          bootstrapURLKeys={{ key: GoogleAPIKey}}
          onChange={this.handleMapChange}
          className={classes.map}
          defaultCenter={this.defaultCenter}
          defaultZoom={this.defaultZoom}
          center={this.center}
          zoom={this.zoom}
          onChildClick={this.handleMarkerClick.bind(this)}
          onGoogleApiLoaded={this.onGoogleAPILoaded}
          yesIWantToUseGoogleMapApiInternals
          >
            {this.renderMarkers()}
          </GoogleMapReact>
        </div>}
      </Paper>
    );
  }
}

const styles = theme => ({
  paper:{
    padding: 20
  },
  mapContainer:{
    height: MAP_HEIGHT,
    marginTop: 10  
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

InventoryLocationsMap.propTypes = {
  customerId: PropTypes.number,
}

export default withRouter(withStyles(styles, {withTheme: true})(InventoryLocationsMap));



// WEBPACK FOOTER //
// ./src/components/InventoryLocationsMap.js